import React from 'react'
import {Container} from 'react-bootstrap';
import withAuth from '../components/authHOC';
import TransactionsTable from '../components/TransactionsTable';

const LoansPage = () => {
    
  return (
       <Container fluid id='users-container'>
       
        <TransactionsTable></TransactionsTable>
    </Container>
  )
}
export default withAuth (LoansPage, ['admin', 'agent'])